import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { flexColumn } from '@/styles/common';

export const Wrapper = styled.div`
  ${flexColumn}
`;

export const CategoryWrapper = styled.div`
  ${flexColumn}
`;

export const CategoryHeader = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 16px 40px;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    padding-inline: 16px;
  }
`;

export const Arrow = styled.div`
  display: inline-flex;
  svg {
    width: 15px;
    height: 15px;
  }
`;

export const CategoryLabel = styled(Typography).attrs({ variant: 'body2' })<{
  $fullWidth?: boolean;
}>`
  color: var(--textAndLabels-main);
  flex: ${({ $fullWidth }) => !!$fullWidth && 1};
`;

export const DiscardLabel = styled(Typography).attrs({ variant: 'body3' })`
  color: var(--textAndLabels-tertiary);
  text-decoration: underline;
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 6px;
`;
